export default __webpack_public_path__ + "static/AD_9645_rgb-7e5a4959915a1728d41bef7bceb575b1.jpg";